import React, { Component } from 'react';
import T from 'i18n-react';

export default class LoaSignConfirmation extends Component {
  closeConfirmWindow=()=>{
    if(typeof this.props.toggleConfirmWindow === 'function'){
      this.props.toggleConfirmWindow()
    }
  }
  confirm=()=>{
    if(typeof this.props.handleSignConfirm === 'function'){
      this.props.handleSignConfirm()
    }
  }
  render(){
    return(
      <section>
        <div className="loa-pop-up">
          <div className="confirmation">
            <h3 className="confirmation__title">
              {T.translate("confirmationHeader")}
            </h3>
            <p className="confirmation__paragraph">
              {T.translate("confirmationBody")}
            </p>
            <div className="confirmation__buttons">
              <button className="btn" onClick={this.closeConfirmWindow}>
                {T.translate("confirmationBtn1")}
              </button>
              <button className="btn" type="submit" onClick={this.confirm}>
                {T.translate("confirmationBtn2")}
              </button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LoaSignConfirmation.js